import {Spin, Button} from 'antd';
import {CheckCircleOutlined, WarningOutlined} from '@ant-design/icons'; // Import specific icons
import React from 'react';

import {STRINGS, getUserErrorMessageByCode, replaceKeys, brandConfig} from '../../utils';
import {NoVNCConnection} from '../noVNCConnection';
import {Timer} from '../timer/timer';
import './userValidateStep.css';

export const UserValidateStep = ({
  userEmail,
  validationInfo,
  validateUser,
  client,
  url
}: any) => {
  const {user: userId, user_uuid, user_k, status: step, additional_data} = validationInfo;
  const {validationErrorCode} = additional_data || {};

  const onRetry = () => {
    validateUser({user_id: userId});
  };

  const defaultStep = (text: string) => {
    return (
      <div className="validate-user-modal__spin">
        <Spin size="large" />
        <div className="validate-user-modal__spin-text">{text}</div>
      </div>
    );
  };

  const steps = {
    created: function () {
      return defaultStep(
        'Starting Validation (The total process will take up to 1 minutes, please don’t close in the middle)'
      );
    },
    in_progress: function () {
      return defaultStep('Requesting code from LinkedIn (Wait, it usually takes up to 1 minute)');
    },
    requests_code: function () {
      return (
        <div className="validate-user-modal__code">
          <Timer initialMinutes={20} />
          <NoVNCConnection
            client={client}
            user={{id: userId, uuid: user_uuid, k: user_k}}
            options={{showCustomAddressBar: false}}
            url={url}
          />
        </div>
      );
    },
    done: function () {
      return (
        <div className="validate-user-modal__success">
          <CheckCircleOutlined />
          <div className="validate-user-modal__success-text">{`User ${userEmail} validated successfully!`}</div>
        </div>
      );
    },
    failed: function () {
      const templateMsg = getUserErrorMessageByCode(validationErrorCode);
      const errorMsg = replaceKeys(
        templateMsg,
        ['{user.email}', '{brandConfig.contact}'],
        [userEmail, brandConfig.contact]
      );

      return (
        <div className="validate-user-modal__error">
          <WarningOutlined />
          <div className="validate-user-modal__error-text">{errorMsg}</div>
          <Button className="validate-user-modal__try-again" onClick={onRetry}>
            Try Again
          </Button>
        </div>
      );
    },
    error: function () {
      const templateMsg = getUserErrorMessageByCode(validationErrorCode) || STRINGS.errors.user.error_default;
      const errorMsg = replaceKeys(
        templateMsg,
        ['{user.email}', '{brandConfig.contact}'],
        [userEmail, brandConfig.contact]
      );

      return (
        <div className="validate-user-modal__error">
          <WarningOutlined />
          <div className="validate-user-modal__error-text">{errorMsg}</div>
          <Button className="validate-user-modal__try-again" onClick={onRetry}>
            Try Again
          </Button>
        </div>
      );
    },
  };

  return steps[step]();
};
